import React, { useContext } from 'react'
import { Row, Cell } from '../Grid'
import { OrgContext } from '../../EmailTemplate'

interface IHeaderProps {
  backgroundColor?: string | null
  logoSrc?: string | null
  companyName?: string | null
}

const Header = ({ data }: { data: IHeaderProps }) => {
  const { backgroundColor, linkColor } = useContext(OrgContext)

  return (
    <Row>
      <style>{`p a, ul a, ol a { color: ${linkColor};  }`}</style>{' '}
      {/* style for links */}
      <Cell
        bgcolor={backgroundColor}
        style={{
          padding: '24px 32px 16px 32px',
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
          textAlign: 'center',
          backgroundColor: backgroundColor,
          backgroundImage: `linear-gradient(${backgroundColor}, ${backgroundColor})` // force background color in Darkmode
        }}
      >
        {(data.logoSrc && (
          <img
            src={data.logoSrc}
            alt={data.companyName ?? 'Organisation logo'}
            title={data.companyName ?? 'Organisation logo'}
            height={64}
            style={{
              maxHeight: '64px',
              maxWidth: '300px',
              width: 'auto',
              height: 'auto',
              display: 'block',
              margin: '0 auto'
            }}
          />
        )) || (
          <h2
            style={{
              color: linkColor,
              WebkitTextFillColor: linkColor, // force text color in Darkmode
              fontSize: '24px',
              lineHeight: '32px',
              fontWeight: 500,
              margin: '8px 0 16px 0',
              textAlign: 'center'
            }}
          >
            {data.companyName}
          </h2>
        )}
      </Cell>
    </Row>
  )
}

export default Header
